module.exports = __webpack_public_path__ + "static/media/info.8124f60f.svg";